<div class="container-fluid">
  <app-page-header
    icon="fe-briefcase"
    pretitle="Registo"
    title="Organizações"
    description="Empresas às quais os clientes pertencem — clientes são associados automaticamente pelo domínio do e-mail."
  >
    @if (auth.can('organization:write')) {
      <a actions class="btn btn-white" [routerLink]="['nova']">
        <i class="fe fe-plus me-1"></i> Nova organização
      </a>
    }
  </app-page-header>
</div>

<div class="container-fluid">
  <!-- Busca -->
  <div class="card">
    <div class="card-body">
      <label class="form-label small text-muted">Procurar</label>
      <input class="form-control" [(ngModel)]="q" (ngModelChange)="onSearch()" placeholder="Nome da organização" />
    </div>
  </div>

  @if (error()) {
    <div class="card"><div class="card-body"><p class="text-danger text-center py-5 mb-0">{{ error() }}</p></div></div>
  } @else if (loading()) {
    <div class="card"><div class="card-body"><p class="text-muted text-center py-5 mb-0">A carregar…</p></div></div>
  } @else if (total() === 0) {
    <div class="card">
      <div class="card-body text-center py-6 px-4">
        <span class="avatar avatar-lg mb-3">
          <span class="avatar-title fs-1 rounded bg-primary-soft text-primary"><i class="fe fe-briefcase"></i></span>
        </span>
        @if (q) {
          <h4 class="mb-1">Nenhuma organização com esta busca</h4>
          <p class="text-muted small mb-0">Experimente outro termo.</p>
        } @else {
          <h4 class="mb-1">Ainda não há organizações</h4>
          <p class="text-muted small mb-3">
            As organizações agrupam clientes pela empresa — os clientes entram automaticamente pelo domínio do e-mail.
          </p>
          <a class="btn btn-sm btn-primary" routerLink="nova"><i class="fe fe-plus me-1"></i>Nova organização</a>
        }
      </div>
    </div>
  } @else {
    <!-- Grade de cards (inspirada em profile-subscribers do template) -->
    <div class="row">
      @for (o of organizations(); track o.id) {
        <div class="col-12 col-md-6 col-xl-4">
          <div class="card org-card">
            <!-- Capa (banner) -->
            <a [routerLink]="[o.id]" class="org-card-cover" aria-label="Abrir organização"></a>

            <div class="card-body text-center">
              <!-- Avatar quadrado (empresa, não pessoa): logo quando houver, senão a inicial -->
              <a [routerLink]="[o.id]" class="avatar avatar-xl card-avatar org-card-avatar">
                @if (o.logoUrl) {
                  <img [src]="o.logoUrl" [alt]="o.name" class="avatar-img rounded" />
                } @else {
                  <span class="avatar-title rounded">{{ o.name.charAt(0).toUpperCase() }}</span>
                }
              </a>

              <!-- Nome -->
              <h2 class="card-title mb-1">
                <a [routerLink]="[o.id]" class="text-reset">{{ o.name }}</a>
              </h2>

              <!-- Subtítulo -->
              <p class="small text-muted mb-3 org-card-sub">
                {{ o.notes || (o.domains.length + ' domínio(s)') }}
              </p>

              <!-- Domínios -->
              <p class="card-text">
                @for (d of o.domains; track d) {
                  <span class="badge bg-secondary-soft me-1">{{ d }}</span>
                } @empty {
                  <span class="badge bg-secondary-soft">sem domínios</span>
                }
              </p>
            </div>

            <!-- Rodapé -->
            <div class="card-footer card-footer-boxed">
              <div class="row align-items-center justify-content-between">
                <div class="col-auto">
                  <small class="text-muted"><i class="fe fe-calendar me-1"></i>{{ o.createdAt | date: 'dd/MM/yyyy' }}</small>
                </div>
                <div class="col-auto">
                  <a [routerLink]="[o.id]" class="btn btn-sm btn-white">Ver</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>

    @if (total() > pageSize) {
      <app-pagination [total]="total()" [page]="page()" [pageSize]="pageSize" (pageChange)="onPage($event)" />
    }
  }
</div>
